import React from 'react';
import './Logo.scss';

function Logo() {
  return <div className="ntc-logo"></div>;
}

export default Logo;
